import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Anderson Acevedo
 * 
 * @version jdesk_1.01.0003
 */
/**
 * CustomReclasificarUbicaciones
 **/
class CustomReclasificarUbicaciones extends FormJaivana.form {

    constructor(props) {

        super(props);
        this.initForm = this.initForm.bind(this);


        this.limpiarCampos = this.limpiarCampos.bind(this);
        this.gridOptionsComponentes = Object.assign({}, this.gridOptions);
        this.onSelectionChangedPrincipal                                  = this.onSelectionChangedPrincipal.bind(this);
        this.gridOptionsComponentes['onSelectionChanged']           = this.onSelectionChangedPrincipal;

        this.mostrarMensajeNoHayDatos = this.mostrarMensajeNoHayDatos.bind(this);
        this.mostrarMensajeAdicional = this.mostrarMensajeAdicional.bind(this);
        this.mostrarMensajeGenerando = this.mostrarMensajeGenerando.bind(this);
        this.traerPropiedades = this.traerPropiedades.bind(this);
        this.sucesstraerPropiedades = this.sucesstraerPropiedades.bind(this);

        this.sucessActualizar = this.sucessActualizar.bind(this);
        this.grabarReclasificacion = this.grabarReclasificacion.bind(this);
        this.consultarSaldos = this.consultarSaldos.bind(this);
        this.sucessconsultarSaldos = this.sucessconsultarSaldos.bind(this);
        //imprimir

        this.mostrarMensajeEmailFallo                         =this.mostrarMensajeEmailFallo.bind(this);
        this.mostrarMensajeEmailEnviado                         =this.mostrarMensajeEmailEnviado.bind(this);


        this.currencyFormatterGeneral = this.currencyFormatterGeneral.bind(this);
        this.formatNumberSaldo = this.formatNumberSaldo.bind(this);
        this.servicio = '';
        this.sucursal_ingreso = '';
        this.numero_decimales = 2;
        this.fila_seleccionada=[];
        this.array_columnas=[];
        this.tamano_formato=4;
    }

    initForm() {
        console.log('Formulario CustomReclasificarUbicaciones,  @version: jdesk_1.01.0003, @author:Anderson Acevedo');
        this.sucursal_ingreso = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;
        this.traerPropiedades();

        this.getField('nombre_articulo').setOnChange((props) => {
            this.getField('nombre_articulo').setError(false,'');
            this.limpiarCampos();
            if(this.getField('nombre_articulo').getValue()!=='' && this.getField('nombre_articulo').getValue()!==' ')
                this.consultarSaldos();
        });

        this.getField('select_ubicaciones').setOnChange((props) => {
            this.limpiarCampos();
            if(this.getField('nombre_articulo').getValue()!=='' && this.getField('nombre_articulo').getValue()!==' ')
                this.consultarSaldos();
        });

        this.getField('ubicacion_origen').setOnBlur((props) => {
            if(this.getField('ubicacion_origen').getValue()!=='' && this.getField('ubicacion_origen').getValue()!==' '){
                if(this.getField('ubicacion_origen').getValue().toString().length===12){
                    this.getField('estante_origen').setValue(this.getField('ubicacion_origen').getValue().toString().trim().substring(0, 4));
                    this.getField('columna_origen').setValue(this.getField('ubicacion_origen').getValue().toString().trim().substring(4, 8));
                    this.getField('estiba_origen').setValue(this.getField('ubicacion_origen').getValue().toString().trim().substring(8, 12));
                }else{
                    this.mostrarMensajeAdicional('Ubicación Origen Errónea.');
                    this.getField('ubicacion_origen').setValue('');
                    this.getField('estante_origen').setValue('');
                    this.getField('columna_origen').setValue('');
                    this.getField('estiba_origen').setValue('');
                }
            }
        });

        this.getField('ubicacion_destino').setOnBlur((props) => {
            if(this.getField('ubicacion_destino').getValue()!=='' && this.getField('ubicacion_destino').getValue()!==' '){
                if(this.getField('ubicacion_destino').getValue().toString().length===12){
                    this.getField('estante_destino').setValue(this.getField('ubicacion_destino').getValue().toString().trim().substring(0, 4));
                    this.getField('columna_destino').setValue(this.getField('ubicacion_destino').getValue().toString().trim().substring(4, 8));
                    this.getField('estiba_destino').setValue(this.getField('ubicacion_destino').getValue().toString().trim().substring(8, 12));
                }else{
                    this.mostrarMensajeAdicional('Ubicación Origen Errónea.');
                    this.getField('ubicacion_destino').setValue('');
                    this.getField('estante_destino').setValue('');
                    this.getField('columna_destino').setValue('');
                    this.getField('estiba_destino').setValue('');
                }
            }
        });


 
        this.getField('bt_grabar').setClick(()=>{
            this.grabarReclasificacion();
        });

    }

    onSelectionChangedPrincipal(){

    }


    grabarReclasificacion(){
        let errores=0;
        if(this.getField('ubicacion_origen').getValue()===this.getField('ubicacion_destino').getValue()){
            errores++;
            this.mostrarMensajeAdicional('Las ubicaciones origen y destino son iguales.');
            return;
        }

        if(errores===0){
            if(this.getField('select_ubicaciones').valid() &&
            this.getField('codigo_articulo').valid() &&
            this.getField('nombre_articulo').valid() &&
            this.getField('ubicacion_origen').valid() &&
            this.getField('ubicacion_destino').valid() &&
            this.getField('cantidad').valid() ){
                this.mostrarMensajeGuardando();
                let datos={ datos: {
                    sucursal_ingreso:this.sucursal_ingreso,
                    cantidad :this.getField('cantidad').getValue(),
                    select_ubicaciones :this.getField('select_ubicaciones').getValue(),
                    codigo_articulo :this.getField('codigo_articulo').getValue(),
                    ubicacion_destino :this.getField('ubicacion_destino').getValue(),
                    ubicacion_origen :this.getField('ubicacion_origen').getValue(),

                }};
                this.generalFormatPmv = { tipo_servicio: 'inve-reclasificarubicaciones', operacion: 'grabar', operacion_tipo: 'crear' };
                this.service.send(
                {
                        endpoint: this.constant.formConfiguration(),
                        method:'POST',
                        body: datos,
                        success: this.sucessActualizar,
                        error: this.error_,
                        general: this.generalFormatPmv,
                        showMessage: false
                });
            }else{
                this.mostrarMensajeAdicional('Existe un campo vacío o mal configurado.');
            }
        }
    }

    sucessActualizar(data) {
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){
            this.mostrarMensajeAdicional('Terminado.');
            this.limpiarCampos();
            this.getField('codigo_articulo').setValue('');
            this.getField('nombre_articulo').setValue('');
        }else {
          if(data.estado_p===404) {
            this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
          }
          else {
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
          }
        }
      }



    traerPropiedades() {
        let datos = { datos: {
            sucursal_ingreso:this.sucursal_ingreso
        } };
        this.generalFormatPmv = { tipo_servicio: 'inve-reclasificarubicaciones', operacion: 'traerpropiedades', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraerPropiedades,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraerPropiedades(data) {
        this.getField('confirmModalCustom').toggle(false);
        
        if (data.estado_p === 200) {
            this.numero_decimales = data.data.numero_decimales;
            this.wms_nuevo = data.data.wms_nuevo;

            if(this.wms_nuevo!=='N'){
                this.getField('select_ubicaciones').setVisible(false);
                this.getField('codigo_articulo').setVisible(false);
                this.getField('nombre_articulo').setVisible(false);

                this.getField('bt_grabar').setVisible(false);
                this.getField('ubicacion_origen').setVisible(false);
                this.getField('estante_origen').setVisible(false);
                this.getField('columna_origen').setVisible(false);
                this.getField('estiba_origen').setVisible(false);
                this.getField('ubicacion_destino').setVisible(false);
                this.getField('estante_destino').setVisible(false);
                this.getField('columna_destino').setVisible(false);
                this.getField('estiba_destino').setVisible(false);
                this.getField('cantidad').setVisible(false);

                this.mostrarMensajeAdicional('OPCIÓN NO AUTORIZADA! (I0071)');
            }
        } else if (data.estado_p === 404) {
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    consultarSaldos() {
        if(this.getField('select_ubicaciones').valid() && this.getField('codigo_articulo').valid()){
            this.mostrarMensajeGenerando();
            let datos = { datos: {
                sucursal_ingreso:this.sucursal_ingreso,
                codigo_articulo:this.getField('codigo_articulo').getValue(),
                select_ubicaciones:this.getField('select_ubicaciones').getValue(),
            } };
            this.generalFormatPmv = { tipo_servicio: 'inve-reclasificarubicaciones', operacion: 'traersaldos', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.sucessconsultarSaldos,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
        }
    }

    sucessconsultarSaldos(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            //dibujar tabla
            this.getField("rejilla").toggle(true);
            this.gridOptionsComponentes["rowData"] = data.data;
            let configCell = new Map();
            configCell.set('saldo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo) }, cellStyle: {textAlign:"right"}});
            configCell.set('cantidad', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad) }, cellStyle: {textAlign:"right"}});

            this.getField('rejilla').initData(this.gridOptionsComponentes,configCell);

            this.getField('bt_grabar').setError(false,'');
            this.getField('ubicacion_origen').setError(false,'');
            this.getField('estante_origen').setError(false,'');
            this.getField('columna_origen').setError(false,'');
            this.getField('estiba_origen').setError(false,'');
            this.getField('ubicacion_destino').setError(false,'');
            this.getField('estante_destino').setError(false,'');
            this.getField('columna_destino').setError(false,'');
            this.getField('estiba_destino').setError(false,'');
            this.getField('cantidad').setError(false,'');

            this.getField('bt_grabar').setValue('');
            this.getField('ubicacion_origen').setValue('');
            this.getField('estante_origen').setValue('');
            this.getField('columna_origen').setValue('');
            this.getField('estiba_origen').setValue('');
            this.getField('ubicacion_destino').setValue('');
            this.getField('estante_destino').setValue('');
            this.getField('columna_destino').setValue('');
            this.getField('estiba_destino').setValue('');
            this.getField('cantidad').setValue('');

            this.getField('bt_grabar').setVisible(true);
            this.getField('ubicacion_origen').setVisible(true);
            this.getField('estante_origen').setVisible(true);
            this.getField('columna_origen').setVisible(true);
            this.getField('estiba_origen').setVisible(true);
            this.getField('ubicacion_destino').setVisible(true);
            this.getField('estante_destino').setVisible(true);
            this.getField('columna_destino').setVisible(true);
            this.getField('estiba_destino').setVisible(true);
            this.getField('cantidad').setVisible(true);

        } else if (data.estado_p === 404) {
            this.mostrarMensajeNoHayDatos();
        }
        else {
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }



    limpiarCampos() {

        this.getField('rejilla').toggle(false);
    

        this.getField('bt_grabar').setVisible(false);
        this.getField('ubicacion_origen').setVisible(false);
        this.getField('estante_origen').setVisible(false);
        this.getField('columna_origen').setVisible(false);
        this.getField('estiba_origen').setVisible(false);
        this.getField('ubicacion_destino').setVisible(false);
        this.getField('estante_destino').setVisible(false);
        this.getField('columna_destino').setVisible(false);
        this.getField('estiba_destino').setVisible(false);
        this.getField('cantidad').setVisible(false);

    }


    currencyFormatterGeneral(number) {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
        if ((decimal !== 0) && (decimal !== undefined)) {
            if (decimal.length > this.numero_decimales) {
                number = number.toFixed(this.numero_decimales); //para que redondea a dos decimales
                decimal = (number + "").split(".")[1];
            }
            return (this.formatNumberSaldo(number) + "," + decimal);
        } else {
            return this.formatNumberSaldo(number);
        }
    }

    formatNumberSaldo(number) {
        return Number(number).toFixed(this.numero_decimales).toString().split('.')[0]
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }


    mostrarMensajeGuardando(){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeAdicional(mensaje) {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeGenerando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);

    }

    mostrarMensajeNoHayDatos() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La consulta no arrojo datos.');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    //mensajes correo

    mostrarMensajeEmailEnviado() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Email enviado exitosamente...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeEmailFallo() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', 'Error al enviar el email...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }


}
FormJaivana.addController("inve-reclasificarubicaciones", CustomReclasificarUbicaciones);
export default CustomReclasificarUbicaciones